module.exports = __webpack_public_path__ + "static/media/dkovacs.8a81a4a4.jpg";